import React from 'react';

export const formatActivityDate = (value) => {
  if (!value) return 'N/A';
  return new Date(value).toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
};

export const formatDuration = (seconds) => {
  if (!seconds) return '0s';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h ? `${h}h` : null, m ? `${m}m` : null, `${s}s`].filter(Boolean).join(' ');
};

const TYPE_STYLES = {
  page_view: 'bg-blue-100 text-blue-800',
  query: 'bg-slate-100 text-slate-700',
  change: 'bg-amber-100 text-amber-800',
  ingest: 'bg-emerald-100 text-emerald-800'
};
const TYPE_LABELS = { page_view: 'MENU', query: 'QUERY', change: 'CHANGE', ingest: 'API INGEST' };

export const ActivityTypeBadge = ({ type }) => (
  <span data-testid={`activity-type-${type}`} className={`px-2 py-0.5 rounded-full text-[10px] font-semibold tracking-wide ${TYPE_STYLES[type] || 'bg-gray-100 text-gray-700'}`}>
    {TYPE_LABELS[type] || (type || '').toUpperCase()}
  </span>
);

export const QueryChips = ({ query }) => {
  const entries = Object.entries(query || {});
  if (entries.length === 0) return <span className="text-xs" style={{ color: 'var(--text-muted-color)' }}>—</span>;
  return (
    <div className="flex flex-wrap gap-1">
      {entries.map(([k, v]) => (
        <span key={k} className="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] font-mono text-gray-700" title={`${k}=${v}`}>
          <span className="text-gray-500">{k}=</span>{String(v).length > 40 ? `${String(v).slice(0, 40)}…` : String(v)}
        </span>
      ))}
    </div>
  );
};

export const StatusCodeBadge = ({ code }) => {
  const ok = code >= 200 && code < 300;
  const warn = code >= 400 && code < 500;
  return (
    <span className={`px-1.5 py-0.5 rounded text-[11px] font-mono ${ok ? 'bg-green-100 text-green-800' : warn ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`}>
      {code}
    </span>
  );
};

export const downloadCsv = (filename, headers, rows) => {
  const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const csv = [headers.map(esc).join(','), ...rows.map((r) => r.map(esc).join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
